import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { FundWalletModalComponent } from 'src/app/non-admin/modals/fund-wallet-modal/fund-wallet-modal.component';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';

@Component({
  selector: 'app-all-transaction-history',
  standalone: false,
  templateUrl: './all-transaction-history.component.html',
  styleUrl: './all-transaction-history.component.scss'
})
export class AllTransactionHistoryComponent implements OnInit{

  action_idx: any = null;

  transactions: any[] = [];
  form!: FormGroup;
  balance: number = 0.0;

  isSearching: boolean = false;
  searchForm: FormGroup;
  showSearchForm: boolean = false;

  // searchedSuperAgentNotFound = false;
  searchedtransactionsNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      transactionType: [''],
      transactionStatus: [''],
      status: [''],
      from: [''],
      to: [''],
      offset: [''],
    });
    this.getUserWallet();
    this.search();
  }

  getUserWallet() {
    let url = '/wallet/user-wallet';
    this.apiService.get(url).subscribe({
      next: (response) => {
        if (response) {
          const { data } = response;
          this.balance = data?.accountBalance;
        }
      },
      error: (error) => {
        this.openErrorModal(error?.message);
      },
    });
  }


  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {

    this.currentPage = 1;

    this.page = 0;

    this.search()
  }

  search() {
    this.transactions = [];
    this.searchedtransactionsNotFound = false;
    this.isSearching = true;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    this.pageSize = this.selectedLimit

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);


    this.apiService
      .post('/transaction/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.transactions = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedtransactionsNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.searchedtransactionsNotFound = true;
        }
      );
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
}
